import * as React from "react";
import { logger } from "bernie-core";
import { inject } from "mobx-react";
import { LobNavigation } from "src/components/shared/StorefrontWizard/LobNavigation";
import { LobForms } from "src/components/shared/StorefrontWizard/LobForm";
import { CentralizedWizardRegionProps } from "./typings";
import { LobQueryRouter } from "components/shared/StorefrontWizard/LobQueryRouter";
import {
  BlossomComponentFactory,
  BlossomComponentFactoryProps,
} from "components/flexFramework/domain/BlossomComponentFactory";
import { CustomerNotifications } from "components/shared/CustomerNotifications";

@logger("CentralizedWizardRegion")
@inject("wizardState")
export class CentralizedWizardRegion extends React.Component<CentralizedWizardRegionProps> {
  public render() {
    const { context, wizardState, flexComponent } = this.props;
    const blossomComponent = BlossomComponentFactory.get(this.props as BlossomComponentFactoryProps);

    if (!flexComponent || !flexComponent.model || !blossomComponent) {
      return null;
    }

    const children = blossomComponent.renderChildren(this.props.logger, this.props.l10n, context);

    if (children.length < 1) {
      return null;
    }

    const wizardLobs = flexComponent.modules;
    const cometSFPadding =
      flexComponent.model.brandModulePadding && flexComponent.model.brandModulePadding === "comet_padding"
        ? "comet-homepage-module"
        : "";

    if (flexComponent.model.defaultLOB) {
      wizardState.globalWizardState.config.navigation.defaultLob = flexComponent.model.defaultLOB;
      wizardState.globalWizardState.config.navigation.activeLob = flexComponent.model.defaultLOB;
    }

    return (
      <div className={`CentralizedWizardRegion ${cometSFPadding} all-b-margin-three`}>
        <div
          className="uitk-grid SimpleContainer uitk-flat-border-top uitk-flat-border-bottom"
          data-testid="centralized-region"
        >
          <div className="uitk-grid uitk-flex uitk-flex-justify-content-center">
            <div
              className="uitk-cell all-cell-1-1 all-x-padding-three s-y-padding-three m-y-padding-six l-y-padding-twelve xl-y-padding-twelve"
              data-testid="centralized-wizard-region"
            >
              <LobQueryRouter lobs={wizardLobs} />
              <CustomerNotifications location="AFTER_HEADER" className="all-b-margin-six" />
              <LobNavigation lobs={wizardLobs} />
              <LobForms lobForms={children} />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CentralizedWizardRegion;
